module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXBAMAAAAIOCkdAAAAAXNSR0IB2cksfwAAADBQTFRFAAAA////////////////////////////////////////////////////////////O00EMAAAABB0Uk5TACCA/2+gnxDPMO/fYH9AwPduXugAAAB4SURBVHicY2AAA0YGFKDsgMxjNTZD4rEnGxsnILgVxsbGFgVwyWYg17gdxp0F4hlbT4DwOBeDucYrIdxTEJ6x1QEQj8cYBmzALoBzjS+AXIAAQLfUvQuG8eLeFSCrVmCAarb//x+Za8DAQAfuIyUlIENJSekBAwMAgE8sNMD95F4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/images/home_icon.png
// module id = 3847
// module chunks = 0